import { isEmpty } from 'lodash';
import styled, { css } from 'styled-components';

import { Translate } from '@dreryk/react-common';
import { basicSmallTextStyle, Text } from '@dreryk/react-components';

import { sharedTranslationKeys } from '../../translations';

import { Specialties } from './specialties.types';

type StyledSpecialtiesTextProps = {
   $compact: boolean | undefined;
   $secondary: boolean | undefined;
};

const StyledSpecialtiesText = styled(Text)<StyledSpecialtiesTextProps>`
   ${(props) =>
      props.$secondary &&
      css`
         color: ${props.theme.placeholder};
      `}

   ${(props) =>
      props.$compact &&
      css`
         ${basicSmallTextStyle}
      `}
`;

StyledSpecialtiesText.displayName = 'StyledSpecialtiesText';

type SpecialtiesProps = {
   readonly specialties: Specialties;
   readonly compact?: boolean;
   readonly secondary?: boolean;
};

export const SpecialtiesText = (props: SpecialtiesProps): JSX.Element => {
   return (
      <StyledSpecialtiesText testId={'specialties'} $compact={props.compact} $secondary={props.secondary}>
         {isEmpty(props.specialties) ? (
            <Translate>{sharedTranslationKeys.specialties.noSpecialties}</Translate>
         ) : (
            props.specialties.join(', ')
         )}
      </StyledSpecialtiesText>
   );
};
